import React, { useState } from 'react';
import { LuEye, LuEyeOff } from 'react-icons/lu';
import { FieldError, FieldHint, FieldInput, FieldLabel, FieldWrap, PasswordToggle } from './AuthLayout.styles';

/* Input used inside <Form.Item>, which injects name, value, onChange, error, label, etc. */
function AuthField({ name, label, type = 'text', value, onChange, error, placeholder, hint, autoComplete }) {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === 'password';

  return (
    <FieldWrap>
      {label && <FieldLabel htmlFor={name}>{label}</FieldLabel>}
      <div className="control">
        <FieldInput
          id={name}
          name={name}
          type={isPassword && showPassword ? 'text' : type}
          value={value ?? ''}
          onChange={onChange}
          placeholder={placeholder}
          autoComplete={autoComplete}
          aria-invalid={!!error}
          aria-describedby={error ? `${name}Error` : undefined}
          $invalid={!!error}
          $hasToggle={isPassword}
        />
        {isPassword && (
          <PasswordToggle
            type="button"
            onClick={() => setShowPassword(v => !v)}
            aria-label={showPassword ? 'Hide password' : 'Show password'}>
            {showPassword ? <LuEyeOff /> : <LuEye />}
          </PasswordToggle>
        )}
      </div>
      {error ? (
        <FieldError id={`${name}Error`} role="alert">
          {error}
        </FieldError>
      ) : (
        hint && <FieldHint>{hint}</FieldHint>
      )}
    </FieldWrap>
  );
}

export default AuthField;
